import type { SVGProps } from "react";
import React from "react";
export function ErrorAlert(props: SVGProps<SVGSVGElement>) {
  return (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#B71B1C"
      d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2Zm1 15h-2v-2h2v2Zm0-4h-2V7h2v6Z"
    />
  </svg>
  );
}
